import api from '@shared/services/api';

export const excessByEmployerService = {
    getExcessByEmployerById: async (id) => {
        const response = await api.get(`/hr-compensation-from-emplr/${id}`);
        return response.data;
    },
    getExcessByEmployers: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.pageNumber !== undefined) queryParams.append('page', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('size', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortDir', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-compensation-from-emplr${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    createExcessByEmployer: async (data) => {
        const response = await api.post('/hr-compensation-from-emplr', data);
        return response.data;
    },
    updateExcessByEmployer: async (id, data) => {
        const response = await api.put(`/hr-compensation-from-emplr/${id}`, data);
        return response.data;
    },
    deleteExcessByEmployer: async (id) => {
        const response = await api.delete(`/hr-compensation-from-emplr/${id}`);
        return response.data;
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-compensation-from-emplr/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-compensation-from-emplr/translate', data);
        return response.data;
    },
    getExcessByEmployerReportData: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Hardcoded langCode as per requirements
        queryParams.append('langCode', 'en_US');
        
        // Handle search query (reason, kindOfCompensation)
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-compensation-from-emplr/report${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    }
};

